// ✅ US Market Tutorials - Thin Wrapper (DRY principle)
import TutorialsPage from '../../sub/tutorials';
import SEOHead from '../../../components/SEOHead';

export default function USTutorials() {
  return (
    <>
      <SEOHead
        title='Tutorials | Web Development Guides | LBVisible'
        description='Learn web development, SEO, and digital marketing through our comprehensive tutorials.'
        keywords='web development tutorials, SEO guides, digital marketing tutorials'
        canonicalUrl='/us/sub/tutorials'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/sub/tutorials' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/sub/tutorials' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/sub/pamokos' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/sub/tutorials' },
        ]}
      />

      <TutorialsPage />
    </>
  );
}
